












































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import moment from 'moment';
import PlateInput from '@/components/plate-input/index.vue';
import * as _ from 'lodash';
import ManualPushSms from './compontents/manual-push-sms.vue';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import { queryMonthCardList, getSmsTemplate } from '@/api/fixed-car-management';
import { MESSAGE_COLLECTION_RECORD } from '../router-names';
import Utils from '@root/utils/common';
import { authStatusMap } from '@/types/fixed-car-management/dictionaries';
// form表单项定义
export interface IForm {
  password: string;
  passwordTwo: string;
}
@Component({
  name: 'FixedVehicle',
  components: {
    ParkingLotSearch,
    ManualPushSms,
    PlateInput
  }
})

// @Component
export default class GangStopPerson extends Mixins(TableMixin, TableWidthMixin) {
  queryChannelListDebounce: any = function() {}; // 列表防抖请求

  selectedRowKeys: any = [];
  selectedRows: any = [];
  onSelectChange(selectedRowKeys, selectedRows) {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    this.selectedRowKeys = selectedRowKeys;
    this.selectedRows = selectedRows;
    // if (selectedRows && selectedRows.length > 0) {
    //   selectedRowKeys.forEach((item, index) => {
    //     this.selectedRowKeys.push({ index: index + 1, ...item })
    //   })
    // }
  }

  tableLoading = false; //表单数据loading
  tableData: any[] = []; // 表数据
  filterParam: any = {
    useType: '01',
    parkIds: [],
    code: '',
    userType: '01',
    userValue: '',
    plateHead: '',
    plateTail: '',
    status: '',
    expire: ''
  };
  clearPlate: boolean = false;
  private authStatusList = Utils.toLabelVal(authStatusMap);
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '姓名',
        dataIndex: 'userName',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '手机号',
        dataIndex: 'phoneNum',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车位号',
        dataIndex: 'code',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '套餐用途',
        dataIndex: 'category',
        width: 140,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '收费套餐',
        dataIndex: 'packageName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '授权状态',
        dataIndex: 'statusString',
        width: 140
      },
      {
        title: '授权期起',
        dataIndex: 'startDate',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '授权期止',
        dataIndex: 'endDate',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '房间号',
        dataIndex: 'roomNum',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      }
    ];
  }

  // 生命周期初始化表单
  created() {
    this.fetchTableData();
    this.getSmsTemplateList();
  }
  isvisible = false;
  //手动推送
  manualPush() {
    if (this.selectedRowKeys.length > 0) {
      return (this.isvisible = true);
    }
    return this.$message.error('请选择需要手动推送的套餐');
  }
  //关闭
  closeModel() {
    this.isvisible = false;
  }
  //发送成功关闭
  okModel() {
    this.selectedRowKeys = [];
    this.selectedRows = [];
    this.isvisible = false;
  }
  /**
   * 请求数据列表
   */
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return;
    this.tableLoading = true;
    this.selectedRowKeys = [];
    this.selectedRows = [];
    if (isRefresh) this.current = 1;
    const { parkIds, ...rest } = this.filterParam;
    try {
      const { status, code, msg, data } = await queryMonthCardList({
        parkId: parkIds.join(','),
        ...rest,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (e) {
      // console.log('queryParkList error')
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  // 车牌号
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }
  //搜索
  searchTableData() {
    this.fetchTableData(true);
  }
  // 清空搜索条件
  onTableFilterClear({ defaultParkIdList }) {
    this.clearPlate = true;
    this.filterParam = {
      parkIds: defaultParkIdList,
      useType: '01',
      code: '',
      userType: '01',
      userValue: '',
      plateHead: '',
      plateTail: '',
      status: '',
      expire: ''
    };
    this.fetchTableData(true);
  }

  toMcrd() {
    this.$router.push({
      name: MESSAGE_COLLECTION_RECORD
    });
  }
  optionList: any[] = [];
  //获取模板列表
  async getSmsTemplateList() {
    try {
      const { data } = await getSmsTemplate({});
      this.optionList = data;
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
}
